import * as React from 'react';
import { jsx, css, keyframes } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';

const { tablet, mobile } = mediaQueries();

const setLoadingColor = (transmissivity: number): string => `rgba(219, 242, 224, ${transmissivity})`;

export const Loading = () => {
  return (
    <div
      className='loading-view is-show'
      css={css`
        background-color: rgba(0 0 0 / 0.4);
        width: 100%;
        height: 100dvh;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        display: none;

        ${tablet(() => css`
          width: 100dvw;
        `)}

        &.is-show {
          display: block;
        }
      `}
    >
      <div
        css={css`
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          width: 1em;
          height: 1em;
          margin: auto;
          font-size: 20px;
          border-radius: 50%;
          animation: ${keyframes`
            0%,
            100% {
              box-shadow: 0 -2.6em 0 0 ${setLoadingColor(1)}, 1.8em -1.8em 0 0 ${setLoadingColor(0.2)}, 2.5em 0 0 0 ${setLoadingColor(0.2)}, 1.75em 1.75em 0 0 ${setLoadingColor(0.2)}, 0 2.5em 0 0 ${setLoadingColor(0.2)}, -1.8em 1.8em 0 0 ${setLoadingColor(0.2)}, -2.6em 0 0 0 ${setLoadingColor(0.5)}, -1.8em -1.8em 0 0 ${setLoadingColor(0.7)};
            }
            12.5% {
              box-shadow: 0 -2.6em 0 0 ${setLoadingColor(0.7)}, 1.8em -1.8em 0 0 ${setLoadingColor(1)}, 2.5em 0 0 0 ${setLoadingColor(0.2)}, 1.75em 1.75em 0 0 ${setLoadingColor(0.2)}, 0 2.5em 0 0 ${setLoadingColor(0.2)}, -1.8em 1.8em 0 0 ${setLoadingColor(0.2)}, -2.6em 0 0 0 ${setLoadingColor(0.2)}, -1.8em -1.8em 0 0 ${setLoadingColor(0.5)};
            }
            25% {
              box-shadow: 0 -2.6em 0 0 ${setLoadingColor(0.5)}, 1.8em -1.8em 0 0 ${setLoadingColor(0.7)}, 2.5em 0 0 0 ${setLoadingColor(1)}, 1.75em 1.75em 0 0 ${setLoadingColor(0.2)}, 0 2.5em 0 0 ${setLoadingColor(0.2)}, -1.8em 1.8em 0 0 ${setLoadingColor(0.2)}, -2.6em 0 0 0 ${setLoadingColor(0.2)}, -1.8em -1.8em 0 0 ${setLoadingColor(0.2)};
            }
            37.5% {
              box-shadow: 0 -2.6em 0 0 ${setLoadingColor(0.2)}, 1.8em -1.8em 0 0 ${setLoadingColor(0.5)}, 2.5em 0 0 0 ${setLoadingColor(0.7)}, 1.75em 1.75em 0 0 ${setLoadingColor(1)}, 0 2.5em 0 0 ${setLoadingColor(0.2)}, -1.8em 1.8em 0 0 ${setLoadingColor(0.2)}, -2.6em 0 0 0 ${setLoadingColor(0.2)}, -1.8em -1.8em 0 0 ${setLoadingColor(0.2)};
            }
            50% {
              box-shadow: 0 -2.6em 0 0 ${setLoadingColor(0.2)}, 1.8em -1.8em 0 0 ${setLoadingColor(0.2)}, 2.5em 0 0 0 ${setLoadingColor(0.5)}, 1.75em 1.75em 0 0 ${setLoadingColor(0.7)}, 0 2.5em 0 0 ${setLoadingColor(1)}, -1.8em 1.8em 0 0 ${setLoadingColor(0.2)}, -2.6em 0 0 0 ${setLoadingColor(0.2)}, -1.8em -1.8em 0 0 ${setLoadingColor(0.2)};
            }
            62.5% {
              box-shadow: 0 -2.6em 0 0 ${setLoadingColor(0.2)}, 1.8em -1.8em 0 0 ${setLoadingColor(0.2)}, 2.5em 0 0 0 ${setLoadingColor(0.2)}, 1.75em 1.75em 0 0 ${setLoadingColor(0.5)}, 0 2.5em 0 0 ${setLoadingColor(0.7)}, -1.8em 1.8em 0 0 ${setLoadingColor(1)}, -2.6em 0 0 0 ${setLoadingColor(0.2)}, -1.8em -1.8em 0 0 ${setLoadingColor(0.2)};
            }
            75% {
              box-shadow: 0 -2.6em 0 0 ${setLoadingColor(0.2)}, 1.8em -1.8em 0 0 ${setLoadingColor(0.2)}, 2.5em 0 0 0 ${setLoadingColor(0.2)}, 1.75em 1.75em 0 0 ${setLoadingColor(0.2)}, 0 2.5em 0 0 ${setLoadingColor(0.5)}, -1.8em 1.8em 0 0 ${setLoadingColor(0.7)}, -2.6em 0 0 0 ${setLoadingColor(1)}, -1.8em -1.8em 0 0 ${setLoadingColor(0.2)};
            }
            87.5% {
              box-shadow: 0 -2.6em 0 0 ${setLoadingColor(0.2)}, 1.8em -1.8em 0 0 ${setLoadingColor(0.2)}, 2.5em 0 0 0 ${setLoadingColor(0.2)}, 1.75em 1.75em 0 0 ${setLoadingColor(0.2)}, 0 2.5em 0 0 ${setLoadingColor(0.2)}, -1.8em 1.8em 0 0 ${setLoadingColor(0.5)}, -2.6em 0 0 0 ${setLoadingColor(0.7)}, -1.8em -1.8em 0 0 ${setLoadingColor(1)};
            }
          `} 1.1s infinite ease;

          ${autoResponsiveClamp('font-size', 20, 16)}
        `}
      />
    </div>
  );
};
